/**
 * cta-banner-dark block (15 uses)
 *
 * Full-bleed teal gradient CTA section with C1 shape decoration.
 * Matches the homepage "Every system. Every identity." section style,
 * but centered with no right-side asset.
 *
 * Hugo template: blocks/cta-banner-dark.html
 */
import { Button } from "~/components/Button";

export function CTABannerDark({
  heading,
  label,
  button,
}: {
  heading?: string;
  label?: string;
  button?: { text: string; url: string };
}) {
  return (
    <div
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #00343a 0%, #060606 100%)" }}
    >
      {/* Decorative C1 shape — same asset as homepage */}
      <img
        src="/images/home-integrations-bg.png"
        loading="lazy"
        className="absolute -right-20 top-1/2 -translate-y-1/2 h-[120%] w-auto opacity-60 pointer-events-none"
        alt=""
      />
      <div className="relative px-4 md:px-8 py-16 md:py-20 lg:py-28">
        <div className="mx-auto max-w-screen-xl text-center">
          {label && (
            <div className="mb-6 flex justify-center">
              <span className="chip bg-pink-accent/20 text-pink-accent">
                {label}
              </span>
            </div>
          )}
          {heading && (
            <h2 className="mx-auto max-w-3xl font-display text-33 font-bold text-white md:text-[2.375rem] md:leading-[1.15]">
              {heading}
            </h2>
          )}
          {button && (
            <div className="mt-8 md:mt-12">
              <a
                href={button.url}
                className="inline-flex items-center gap-2 font-body font-medium text-dark bg-cream rounded-10 px-6 py-2.5 hover:bg-white transition-colors"
                {...(button.url.startsWith("http") ? { target: "_blank", rel: "noopener" } : {})}
              >
                <span>{button.text}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
